// @flow

import type {InjectIntlProvidedProps} from 'react-intl';
import type {NameValue} from '../../types';

import React from 'react';
import {injectIntl} from 'react-intl';
import {OpenIn} from '@xsolla/design-system-icons';
import classNames from 'classnames/bind';
import {compose} from 'recompose';
import style from './style.css';

type Props = {
  +nameValues: Array<NameValue>
} & InjectIntlProvidedProps;

const cx = classNames.bind(style);
const stylePrefix = 'inline-info';

const InlineInfo = ({intl, nameValues}: Props) => (
  <div className={cx(stylePrefix)}>
    {nameValues.map((nameValue: NameValue, idx: number) => (
      <div className={cx(`${stylePrefix}__item`)} key={`${stylePrefix}__item-${idx}`}>
        <span className={cx(`${stylePrefix}__text`, `${stylePrefix}__text--shadow`)}>
          {nameValue.name}&nbsp;
        </span>
        <span className={cx(`${stylePrefix}__text`, `${stylePrefix}__text--bold`)}>
          {nameValue.value}
        </span>
      </div>
    ))}
    <div className={cx(`${stylePrefix}__item`)} key={`${stylePrefix}__item-documentation`}>
      <a
        href={'https://developers.xsolla.com/solutions/payments/anti-fraud/chargeback/'}
        className={cx('documentation-link')}
        target={'_blank'}>
        <span>
          {intl.messages['app.support.disputes.aggregations.global.dispute-documentation']}
        </span>
        <span className={cx('documentation-link-icon')}>
          <OpenIn size={16} />
        </span>
      </a>
    </div>
  </div>
);

const enhance = compose(injectIntl);

export default enhance(InlineInfo);
